/**
 * @file Environment resolver used by app constants/services.
 * @description Normalizes Vite env access with safe defaults for local and production.
 * @author Sanjay Jangid (Jiggle frontend)
 * @email sanjay.jangid@dgtoohl.com
 * @date 2026-05-10
 * @version 0.0.0
 */
export const getEnv = () => ({
  apiBaseUrl:
    (import.meta.env['VITE_API_BASE_URL'] as string) ||
    (import.meta.env.DEV ? '/api' : 'https://apijiggle.safebima.com/api'),
  appEnv:
    (import.meta.env['VITE_APP_ENV'] as string) ||
    (import.meta.env.DEV ? 'development' : 'production'),
  logLevel: (import.meta.env['VITE_LOG_LEVEL'] as string) || 'info',
});

export type AppEnv = ReturnType<typeof getEnv>;
